import React from 'react'

function ClockIcon({
  className,
  stroke,
  onClick,
  size
}) {
  return (
    <div className={className} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" className={size ? size : `h-6 w-6`} fill="none" viewBox="0 0 24 24" stroke={stroke}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
  )
}

export default ClockIcon
